import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

export interface ChampionDeclineDialogResult {
  confirmed: boolean;
  reason: string;
}

@Component({
  selector: 'app-champion-decline-dialog',
  standalone: false,
  templateUrl: './champion-decline-dialog.component.html',
  styleUrls: ['./champion-decline-dialog.component.scss']
})
export class ChampionDeclineDialogComponent {
  declineReason = '';

  constructor(
    public dialogRef: MatDialogRef<ChampionDeclineDialogComponent>
  ) {}

  onClose(): void {
    this.dialogRef.close(null);
  }

  onCancel(): void {
    this.dialogRef.close(null);
  }

  onDecline(): void {
    this.dialogRef.close({ confirmed: true, reason: this.declineReason } as ChampionDeclineDialogResult);
  }
}
